import type { Locale } from '@/types'

export interface PageRoute {
  name: string
  paths: Record<Locale, string>
  component: () => Promise<unknown>
}

export const pageRoutes: PageRoute[] = [
  {
    name: 'home',
    paths: { fr: '', nl: '', en: '', de: '' },
    component: () => import('@/pages/HomePage.vue'),
  },
  {
    name: 'domein',
    paths: { fr: 'domaine', nl: 'domein', en: 'domain', de: 'domane' },
    component: () => import('@/pages/DomainPage.vue'),
  },
  {
    name: 'gites',
    paths: { fr: 'gites', nl: 'gites', en: 'gites', de: 'gites' },
    component: () => import('@/pages/GitesPage.vue'),
  },
  {
    name: 'gite-detail',
    paths: { fr: 'gites/:slug', nl: 'gites/:slug', en: 'gites/:slug', de: 'gites/:slug' },
    component: () => import('@/pages/GiteDetailPage.vue'),
  },
  {
    name: 'contact',
    paths: { fr: 'contact', nl: 'contact', en: 'contact', de: 'contact' },
    component: () => import('@/pages/ContactPage.vue'),
  },
  {
    name: 'gastenboek',
    paths: { fr: 'livre-dor', nl: 'gastenboek', en: 'guestbook', de: 'gastebuch' },
    component: () => import('@/pages/GuestbookPage.vue'),
  },
  {
    name: 'faq',
    paths: { fr: 'faq', nl: 'faq', en: 'faq', de: 'faq' },
    component: () => import('@/pages/FaqPage.vue'),
  },
  {
    name: 'regio',
    paths: { fr: 'region', nl: 'regio', en: 'region', de: 'region' },
    component: () => import('@/pages/RegionPage.vue'),
  },
  {
    name: 'sport',
    paths: {
      fr: 'sports-activites',
      nl: 'sport-activiteiten',
      en: 'sports-activities',
      de: 'sport-aktivitaten',
    },
    component: () => import('@/pages/SportsPage.vue'),
  },
  {
    name: 'wellness',
    paths: { fr: 'wellness', nl: 'wellness', en: 'wellness', de: 'wellness' },
    component: () => import('@/pages/WellnessPage.vue'),
  },
  {
    name: 'groepen',
    paths: { fr: 'groupes', nl: 'groepen', en: 'groups', de: 'gruppen' },
    component: () => import('@/pages/GroupsPage.vue'),
  },
  {
    name: 'traiteurs',
    paths: { fr: 'traiteurs', nl: 'traiteurs', en: 'caterers', de: 'caterer' },
    component: () => import('@/pages/CaterersPage.vue'),
  },
  {
    name: 'historie',
    paths: {
      fr: 'histoire-du-domaine',
      nl: 'historie-van-het-domein',
      en: 'history-of-the-domain',
      de: 'geschichte-der-domane',
    },
    component: () => import('@/pages/HistoryPage.vue'),
  },
  {
    name: 'voorwaarden',
    paths: {
      fr: 'termes-et-conditions',
      nl: 'algemene-voorwaarden',
      en: 'terms-and-conditions',
      de: 'geschaftsbedingungen',
    },
    component: () => import('@/pages/TermsPage.vue'),
  },
  {
    name: 'covid',
    paths: { fr: 'covid-19', nl: 'covid-19', en: 'covid-19', de: 'covid-19' },
    component: () => import('@/pages/CovidPage.vue'),
  },
  {
    name: 'booking-checker',
    paths: {
      fr: 'booking-checker',
      nl: 'booking-checker',
      en: 'booking-checker',
      de: 'booking-checker',
    },
    component: () => import('@/pages/BookingCheckerPage.vue'),
  },
]

export function getLocalizedPath(name: string, locale: Locale): string {
  const route = pageRoutes.find((r) => r.name === name)
  if (!route) return ''
  const path = route.paths[locale]
  return path ? `/${locale}/${path}` : `/${locale}`
}

export function getRouteNameByPath(path: string, locale: Locale): string | undefined {
  const route = pageRoutes.find((r) => r.paths[locale] === path)
  return route?.name
}
